import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ModalWithExternalHeader from './ModalWithExternalHeader';
import styles from './CompletionModal.css';
import mokaLogo from './images/moka-logo-with-tagline.png';
import ftueCompleteImage from './images/ftue-complete.png';
import Button from './Button';
import Fireworks from './Fireworks';

function CompletionModal(props) {
  const { isShowing, onClose, onReplayButtonClick } = props;
  return (
    <ModalWithExternalHeader show={isShowing} externalHeaderText="Selamat!">
      <Fireworks />
      <Modal.Body className={styles.body}>
        <div className={styles.imageContainer}>
          <img src={mokaLogo} className={styles.logo} />
        </div>

        <div className={styles.imageContainer}>
          <img src={ftueCompleteImage} className={styles.completionImage} />
        </div>

        <p className={styles.description}>
          Anda telah mempelajari fitur-fitur utama dan siap menggunakan Moka!
        </p>

        <div className={styles.footer}>
          <p className={styles.description}>Selesaikan tutorial?</p>
          <div className={styles.actionButtons}>
            <Button
              type="button"
              onClick={onReplayButtonClick}
              className={styles.btnReplay}
            >
              Ulangi Bab
            </Button>
            <Button type="button" onClick={onClose} variant="primary">
              Selesai
            </Button>
          </div>
        </div>
      </Modal.Body>
    </ModalWithExternalHeader>
  );
}

CompletionModal.defaultProps = {
  isShowing: false,
  onClose: () => {},
  onReplayButtonClick: () => {},
};

CompletionModal.propTypes = {
  isShowing: PropTypes.bool,
  onClose: PropTypes.func,
  onReplayButtonClick: PropTypes.func,
};

export default CompletionModal;
